import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export default createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "pages-spotlight-nav4-entry-point" */ './src/ui/PagesSpotlightMaybe.tsx'
			),
	),

	getPreloadProps() {
		return {};
	},
});
